import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" {...this.props}><g fill="none" fillRule="evenodd"><path d="M30.222 31.987c.975 0 1.765-.787 1.765-1.758V1.879c0-.972-.79-1.76-1.765-1.76H1.765A1.763 1.763 0 0 0 0 1.88v28.35c0 .97.79 1.758 1.765 1.758h28.457z" fill="#3C5999" /><path d="M22.07 31.987v-12.34h4.159l.622-4.81h-4.78v-3.07c0-1.393.388-2.342 2.392-2.342l2.556-.001V5.122c-.442-.058-1.96-.19-3.725-.19-3.685 0-6.209 2.242-6.209 6.358v3.547h-4.168v4.81h4.168v12.34h4.986z" fill="#FEFEFE" /></g></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/static/images/sources/facebook.svg